import {
  CreateExamReserveInformationInput,
  UpdateExamReserveInformationInput,
} from 'generated/graphql'
import { removeHyphensFromPhoneNumber } from '../../modules'
import { TPreReservationFormValues } from '../constants/form'

export const parsedUpdateInputValues = (
  values: TPreReservationFormValues,
): UpdateExamReserveInformationInput => {
  return {
    companyId: values.companyId,
    termId: values.termId,
    subsidiaryId: values.subsidiaryId,
    departmentId: values.departmentId,
    jobId: values.jobId,
    testId: values.testId,
    hasAgreedToPrivacy: values.hasAgreedToPrivacy,
  }
}

export const parsedCreateInputValues = (
  values: TPreReservationFormValues,
): CreateExamReserveInformationInput => {
  return {
    companyId: values.companyId,
    termId: values.termId,
    subsidiaryId: values.subsidiaryId,
    departmentId: values.departmentId,
    jobId: values.jobId,
    testId: values.testId,
    phoneNumber: removeHyphensFromPhoneNumber(values.phoneNumber),
    hasAgreedToPrivacy: values.hasAgreedToPrivacy,
  }
}
